(() => {
  class ContactLauncher extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.toggleButton = this.querySelector('[data-contact-toggle]');
      this.menu = this.querySelector('.contact-launcher__menu');
      this.backdrop = this.querySelector('[data-contact-backdrop]');
      this.actionLinks = Array.from(this.querySelectorAll('[data-contact-action]'));

      if (!this.toggleButton || !this.menu || !this.backdrop) return;

      this.handleToggle = () => this.setOpen(!this.isOpen());
      this.handleBackdropClick = () => this.setOpen(false);
      this.handleActionClick = () => this.setOpen(false, { restoreFocus: false });
      this.handleKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen()) {
          event.preventDefault();
          this.setOpen(false);
        }
      };

      this.toggleButton.addEventListener('click', this.handleToggle);
      this.backdrop.addEventListener('click', this.handleBackdropClick);
      this.actionLinks.forEach((link) => {
        link.tabIndex = -1;
        link.addEventListener('click', this.handleActionClick);
      });
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      if (!this.initialized || !this.toggleButton) return;

      this.toggleButton.removeEventListener('click', this.handleToggle);
      this.backdrop.removeEventListener('click', this.handleBackdropClick);
      this.actionLinks.forEach((link) => {
        link.removeEventListener('click', this.handleActionClick);
      });
      document.removeEventListener('keydown', this.handleKeydown);
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    setOpen(shouldOpen, { restoreFocus = true } = {}) {
      this.classList.toggle('is-open', shouldOpen);
      this.toggleButton.setAttribute('aria-expanded', String(shouldOpen));
      this.menu.setAttribute('aria-hidden', String(!shouldOpen));
      this.actionLinks.forEach((link) => {
        link.tabIndex = shouldOpen ? 0 : -1;
      });

      if (shouldOpen) {
        requestAnimationFrame(() => this.actionLinks[0]?.focus());
      } else if (restoreFocus) {
        this.toggleButton.focus();
      }
    }
  }

  if (!customElements.get('contact-launcher')) {
    customElements.define('contact-launcher', ContactLauncher);
  }
})();
